import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import DataTable from '@eig-builder/module-data-table/table'
import CustomLazyLoad from './custom-lazy-load'

const StyledDataTable = styled(DataTable)`
  box-shadow: none !important;
`

const DataTableWrapper = styled.div`
.data-table .data-table-pagination-wrapper {
  border-bottom: 0;
}

li.break > a {
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
`

const DataTableWithoutShadow = ({ loadMoreProps, ...restProps }) => {
  return <DataTableWrapper>
    <StyledDataTable {...restProps} />
    {loadMoreProps && <CustomLazyLoad {...loadMoreProps} />}
  </DataTableWrapper>
}

DataTableWithoutShadow.propTypes = {
  loadMoreProps: PropTypes.object
}

export default memo(DataTableWithoutShadow)
